import styled from '@emotion/styled';
import { Box } from '@mui/material';

const Container = styled(Box)`
  top: var(--header-height);
  left: 0;
  width: 100%;
  height: calc(100vh - var(--header-height));
  overflow: hidden;
  padding: 6vw;
  background: #efefef;
  @media (orientation: landscape) {
    padding: 4vw;
    padding-bottom: 2.9vw;
  }
`;

export default Container;
